import React from "react";
import { NavLink } from "react-router-dom";
import "./TitleSection.css";
import { useTranslation } from "react-i18next";

const splitIntoTwoLines = (text) => {
  const words = text.split(" ");
  const midIndex = Math.ceil(words.length / 2); // Find middle of the sentence
  return [words.slice(0, midIndex).join(" "), words.slice(midIndex).join(" ")];
};

const TitleSection = ({
  title,
  subtitle,
  highlightWords = [],
  bgImg,
  home = false,
}) => {
  const { t } = useTranslation();

  // Function to apply highlighting even if a phrase is split
  const highlightText = (text, phrasesToHighlight) => {
    if (!phrasesToHighlight.length) return text;

    // Escape special characters and match phrases
    const regex = new RegExp(
      `(${phrasesToHighlight
        .map((p) => p.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&"))
        .join("|")})`,
      "gi",
    );

    return text.split(regex).map((part, index) =>
      phrasesToHighlight.some((phrase) => phrase.includes(part.trim())) ? (
        <span key={index} className="text-orange">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  // Split the subtitle into two lines
  const [firstLine, secondLine] = splitIntoTwoLines(subtitle);

  return (
    <section
      id="title-section"
      style={{
        "--bg-image": `url(${bgImg})`,
      }}
    >
      <div
        className={`flex flex-col items-center gap-5 h-full 
          sm:items-start sm:text-left sm:pl-[10vw] ${
            home ? "py-[5vh] sm:py-[30vh]" : "py-[3vh] sm:py-[20vh]"
          }`}
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-title uppercase">
          {title}
        </h1>
        <h2
          className={`italic text-sm sm:text-base md:text-lg ${
            home ? "w-11/12 sm:w-1/3" : "w-11/12 sm:w-full"
          }`}
        >
          {home ? (
            highlightText(subtitle, highlightWords)
          ) : (
            <>
              {highlightText(firstLine, highlightWords)}
              <br />
              {highlightText(secondLine, highlightWords)}
            </>
          )}
        </h2>
        {home && (
          <NavLink to="/a-propos">
            <button className="w-fit text-white bg-orange px-4 py-2 rounded text-sm sm:text-base hover:brightness-75 transition">
              {t("home.about.button")}
            </button>
          </NavLink>
        )}
      </div>
    </section>
  );
};

export default TitleSection;
